export default "__VITE_ASSET__BRub2uzH__"